<template>
    <div class="click-to-enter-overlay"
         @click="dismiss()"
         v-if="clickedOnce != true"
         title="this is just a technical workaround in order to make stuff working"
    >

        <slot>click to go</slot>

    </div>
</template>
<script>
    export default {

        name: 'ClickToEnter',

        data() {

            return {

                clickedOnce : false

            }

        },

        methods: {
            dismiss() {

                this.clickedOnce = true;
                this.$emit("clicked");

            }
        }

    }
</script>
<style lang="scss">
    .click-to-enter-overlay {

        position: fixed;
        top:0;
        left:0;
        width:100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        background: transparent;
        z-index: 10;
        color: white;
        font-size: 18px;
        font-style: italic;
        cursor: pointer;
        background-color: rgba(0,0,0,.75);
      text-align: center;

    }
</style>